// api.js

import axios from 'axios';

const service = axios.create({
  // baseURL: 'https://api.test.hryunyi.com', // 测试环境
  baseURL: 'https://api.haoruiyunyi.com',//正式环境
  timeout: 5000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
  },
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送之前可以进行一些操作，比如添加 token
    // config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 在这里可以对响应进行处理，比如处理错误状态码
    // if (response.status === 200) {
    //   // 处理成功响应
    // }
    return response.data;
  },
  error => {
    // 处理响应错误
    return Promise.reject(error);
  }
);

export default service;
